const normalizeFlag = (value) => {
  if (value === null || value === undefined) return true;
  return Boolean(value);
};

export const normalizeOrderTypeForEligibility = (orderType) => {
  const normalized = String(orderType || "").trim().toUpperCase();
  if (normalized === "TAKEAWAY") return "TAKEAWAY";
  // Treat TABLE_DINEIN as DINEIN for eligibility.
  if (normalized === "TABLE_DINEIN" || normalized === "DINEIN") return "DINEIN";
  return "DINEIN";
};

export const isItemEligibleForOrderType = (item, orderType) => {
  const normalizedOrderType = normalizeOrderTypeForEligibility(orderType);
  const availableInDineIn = normalizeFlag(
    item?.availableInDineIn ?? item?.available_in_dine_in,
  );
  const availableInTakeaway = normalizeFlag(
    item?.availableInTakeaway ?? item?.available_in_takeaway,
  );

  if (normalizedOrderType === "TAKEAWAY") return availableInTakeaway;
  return availableInDineIn;
};

